import { LitElement, html, utils } from '@hh/global.js'

class HHProductCarousel extends LitElement {
  static properties = {
    arrows: {
      type: Boolean,
      attribute: 'arrows',
    },
    pagination: {
      type: Boolean,
      attribute: 'pagination',
    },
    perPage: {
      type: Number,
      attribute: 'per-page',
    },
    carouselClass: {
      type: String,
      attribute: 'data-js-carousel',
    },
    thumbnailClass: {
      type: String,
      attribute: 'data-js-carousel-thumbnail',
    },
  }

  constructor() {
    super()
    this.arrows = false
    this.pagination = false
    this.perPage = 1
    this.carouselClass = ''
    this.thumbnailClass = ''
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleCarousel()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  handleCarousel() {
    const splideExtension = window.splide.Extensions

    this.splide = new Splide(`.${this.carouselClass}`, {
      arrows: false,
      pagination: false,
      perPage: this.perPage,
      fixedWidth: '100%',
      gap: '1px',
      mediaQuery: 'min',
    })

    this.thumbnail = new Splide(`.${this.thumbnailClass}`, {
      arrows: this.arrows,
      pagination: false,
      perPage: 4,
      rewind: true,
      focus: 'center',
      isNavigation: true,
      mediaQuery: 'min',
      breakpoints: {
        750: {
          perPage: 5,
        },
      },
    })

    this.splide.sync(this.thumbnail)
    this.splide.mount(splideExtension)
    this.thumbnail.mount(splideExtension)
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-carousel', HHProductCarousel)
